import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Figure, Form, Modal, Row } from "react-bootstrap";
import {
  addAndUpdateSuvichar,
  addAndUpdateTeam,
  addAndUpdateUser,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { MaxLength } from "../../../utils/constants/CharactersLength";
import { ValidationMessage } from "../../../utils/constants/validationMessage";
import { whiteSpaceCheck } from "../../../helper/helper";
import { Loader } from "lucide-react";
import { BASE_URL } from "../../../services/path";
import AuthContext from "../../../hooks/context/AuthContext";

const AddEdit = ({
  show,
  onHide,
  modalType,
  currentActiveData,
  fetchedGetUsers,
  setCurrentActiveData,
}) => {
  const notification = useToastContext();
  let { user } = useContext(AuthContext);

  // HOOK FORM
  const {
    register,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // ALL STATE
  const [loading, setLoading] = useState(false);

  console.log("user", user);

  const onSubmit = (data) => {
    const userData = { modalTypes: modalType, id: currentActiveData?._id };
    const requestPayload = { suvichar: data?.message, userId: user?._id };
    addAndUpdateSuvichar(
      requestPayload,
      userData,
      notification,
      (loading, error) => {
        setLoading(loading);
        if (!error) {
          fetchedGetUsers();
          onHide();
        }
      }
    );
  };

  useEffect(() => {
    if (modalType == "edit") {
      setValue("message", currentActiveData?.suvichar || "");
    }
  }, [modalType]);

  return (
    <Modal
      show={show}
      onHide={() => {
        setCurrentActiveData({});
        onHide();
      }}
      centered
    >
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="fw-bold fs-5">Add Suvichar</Modal.Title>
      </Modal.Header>
      <Form
        className="common-modal"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        autoComplete="off"
      >
        <Modal.Body className="p-4">
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Message</Form.Label>

                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter your message."
                  name="message"
                  {...register("message", {
                    required: ValidationMessage.FORGOT_TO_ENTER_MESSAGE,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  style={{ resize: "none" }}
                />
                <ErrorMessage
                  errors={errors}
                  name="message"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            type="submit"
            className="bg-orange border-0"
            disabled={loading}
            style={loading ? { cursor: "not-allowed" } : { cursor: "pointer" }}
          >
            Submit{" "}
            {loading && (
              <Loader
                style={{
                  marginLeft: "20px",
                }}
                className="loader"
              />
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEdit;
